/**
 * DA — JavaScript maison pour Prestige 11.
 * Seul reste de l'ancien custom.js : le reste (recherche, filtres, tri, wishlist, stagger)
 * est géré nativement par Prestige 11 ou par les apps elles-mêmes.
 */

/**
 * KaChing cart — agrandir la croix de fermeture sur mobile, sans changer son ancrage.
 */
(function () {
  if (document.getElementById('da-kaching-close-size')) return;
  var style = document.createElement('style');
  style.id = 'da-kaching-close-size';
  style.textContent = [
    '@media (max-width: 760px) {',
    '  #kaching-cart .kaching-cart__header .kaching-cart__close {',
    '    position: absolute !important;',
    '    right: var(--header-padding-x, 12px) !important;',
    '    left: auto !important;',
    '    top: 50% !important;',
    '    transform: translateY(-50%);',
    '    width: 44px !important;',
    '    height: 44px !important;',
    '    min-width: 44px !important;',
    '    min-height: 44px !important;',
    '    display: flex !important;',
    '    align-items: center !important;',
    '    justify-content: center !important;',
    '    padding: 0 !important;',
    '    touch-action: manipulation;',
    '  }',
    '  #kaching-cart .kaching-cart__header .kaching-cart__close > svg {',
    '    width: 22px !important;',
    '    height: 22px !important;',
    '    min-width: 22px !important;',
    '    min-height: 22px !important;',
    '    stroke-width: 2.25 !important;',
    '  }',
    '}'
  ].join('\n');
  (document.head || document.documentElement).appendChild(style);
})();
